module.exports = {
  app: {
    name: 'VIOOH Trading Manager',
  },
  auth0: {
    domain: 'viooh-lab.eu.auth0.com',
    clientID: 'cbkR497qchuon73ZVWxBweWCHJIh1HaF',
    audience: 'https://auth-demo.viooh.com',
    responseType: 'token id_token',
    scope: 'openid profile email offline_access',
  },
  authProvider: 'Auth0',
  apiKeys: {
    googleMap: 'AIzaSyDl84nE7cL3C9gVZJeLUXsXc8N0VqI8MPg',
  },
  dataDog: {
    applicationId: '964f9e51-f2c9-4394-a9c5-a64bc6b09a77',
    clientToken: 'pubd5a5e3010d47232addac501f77d89396',
    site: 'datadoghq.eu',
    service: 'trading-manager-ui',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 1,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  },
  pendo: {
    subscriptionKey: '2f9402fe-931d-4b16-6e49-533b5dad4546',
  },
  isPublisherActive: true,
  thoughtspot: {
    host: 'https://viooh.thoughtspot.cloud/',
    identifier: 'development',
    labsId: '2557f287-a5ef-4d0f-acbd-a947f79154cd',
    resellerDealHealthDashboardId: '17a46a4d-598b-44fe-b4d8-d6042e69ab5d',
    dealHealthDashboardId: '276282e7-c60a-4c18-b4e7-13746616aad7',
    proofOfPlayLiveboardId: '5c3f305e-96cb-4f9e-89e3-ac5a1b3b16ab',
    resellerProofOfPlayLiveboardId: '1a5dbb5b-3875-45e2-9f7e-927e21a39248',
    revenueInsightsLiveboardId: '119cba27-3e47-49ce-9a68-620818a51103',
    inventoryReservationLiveboardId: '3fd6777b-0163-4318-8947-758763616ebd',
    popLiveMonitoringLiveboardId: 'ffba8cd8-1937-4978-bda2-c1e22f673fc1',
    dealManagementMetrics: '1f617b9b-fe13-471e-8429-51766ccb48bc',
    todaysRevenueVizId: 'eb47dc41-ff28-4943-a1cb-487f6d555380',
    monthToDateVizId: '13a518a7-be8e-42f2-8aac-075763d500c9',
    chinaProofOfPlayLiveboardId: 'f0e26617-5acc-46e0-904e-753552a9207b',
    chinaDealHealthLiveboardId: '579e6851-0018-4237-9f9e-a2c096f6e893',
    dealHealthUSDashboardId: '41daaa0c-9b6e-4c39-bd19-fa3e54a7bb5a',
    quickDeliveryStatsLiveboardId: '276282e7-c60a-4c18-b4e7-13746616aad7',
    quickDeliveryStatsVisualizationId: '0f571cdd-4241-440e-9f61-82c240dc00b4',
    assetHealthLiveboardId: '258b2057-b681-458d-b414-e9ec2f76e96d',
  },
  agGrid: {
    enterpriseKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-064387}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{VIOOH_Limited}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{TMUI}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{TMUI}_need_to_be_licensed___{TMUI}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{31_July_2025}____[v3]_[01]_MTc1MzkxNjQwMDAwMA==461dbf31b83bffa84ca695abd4163267',
  },
  URLS: (BASE_URL, DSM_BASE_URL, GATEWAY_BASE_URL) => ({
    SETUPLIST_DATA_URL: (query) => `${BASE_URL}agl/api/v1/setup/list/?updateStamp=0${query}`,
    SETUPLIST_DATA_URL_V2: (query) => `${BASE_URL}agl/api/v2/setup/list/?updateStamp=0${query}`,
    SETUP_POLL_DELTAS_URL_V2: () => `${BASE_URL}agl/api/v2/setup/list?updateStamp=0`,
    SETUP_DOWNLOAD_URL: (fileId) => `${BASE_URL}agl/api/v1/setup/download/${fileId}`,
    SETUP_DOWNLOAD_URL_V2: (fileId) => `${BASE_URL}agl/api/v2/setup/download/${fileId}`,
    SETUP_UPLOAD_FILE: () => `${BASE_URL}agl/api/v1/setup/create`,
    SETUP_UPLOAD_FILE_V2: () => `${BASE_URL}agl/api/v2/setup/create`,
    SETUP_DOWNLOAD_ERROR_REPORT_V2: (fileId) => `${BASE_URL}agl/api/v2/setup/error-report/${fileId}`,
    SETUP_FETCH_FILE_ASSETS: (fileId) => `${BASE_URL}agl/api/v1/setup/detail/${fileId}`,
    SETUP_FETCH_FILE_ASSETS_V2: (fileId) => `${BASE_URL}agl/api/v2/setup/detail/${fileId}`,
    ASSET_LOOKUP: (lookupName) => `${BASE_URL}vcl/api/v1/lookup/${lookupName}`,
    LOOKUP_API: (lookupName) => `${BASE_URL}ag/api/v1/lookup/${lookupName}`,
    CONTENT_DEALID_LOOKUP_API: (query) => `${GATEWAY_BASE_URL}mod/api/v1/moderation/deal?${query}`,
    CREATIVE_ADMIN_DEALID_LOOKUP_API: (query) => `${BASE_URL}mod/api/v1/moderation/admin/deal?${query}`,
    META_DATA: () => `${BASE_URL}ag/api/v1/meta`,
    FETCH_CREATIVES: (query) => `${BASE_URL}mod/api/v1/moderation/creative?${query}`,
    CREATE_CREATIVE: () => `${BASE_URL}mod/api/v1/moderation/creative`,
    FETCH_CREATIVES_DETAILS: (creativeId) => `${BASE_URL}mod/api/v1/moderation/creative/${creativeId}`,
    APPROVE_CREATIVE: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}/approve`,
    FLAG_CREATIVE: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}/flag`,
    PENDING_APPROVE_CREATIVE: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}/pending`,
    SEND_CREATIVE_FOR_APPROVAL: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}/send-for-approval`,
    FETCH_ELIGIBLE_RESELLER_MEDIA_OWNERS: (marketId) =>
      `${BASE_URL}mod/api/v1/moderation/market/${marketId}/eligible-media-owners`,
    FETCH_NON_MEDIA_SERVICES: () => `${BASE_URL}dsc/api/v1/measurements/search`,
    FETCH_SELECTED_NON_MEDIA_SERVICES: () => `${BASE_URL}dsc/api/v1/activations/search`,
    REJECT_CREATIVE: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}/reject`,
    ADD_CREATIVE_DEALID: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}/deal`,
    DELETE_CREATIVE_DEALID: (dealId) => `${BASE_URL}mod/api/v1/moderation/market/deal/${dealId}`,
    CREATIVE_FRAME_SUMMARY: (creativeId, environment) =>
      `${BASE_URL}mod/api/v1/moderation/creative/${creativeId}/frame/count?environment=${environment}`,
    CREATIVE_EXPORT_FRAME_SUMMARY: (creativeId, environment) =>
      `${BASE_URL}mod/api/v1/moderation/creative/${creativeId}/frame/export?environment=${environment}`,
    DEAL_LIST_BIDS_DATA_URL: () => `${BASE_URL}api/v1/deal/list`,
    BRAND_LOOKUP: () => `${BASE_URL}ag/api/sspui/v1/lookup/brand`,
    POI_LIST: () => `${BASE_URL}carto/v1/carto3/poiOptions`,
    POI_DATA: () => `${BASE_URL}carto/v1/carto3/poidata`,
    GET_USER_LIST: (qryText, pageNu, pageSize) => {
      let url = `${BASE_URL}um/api/v1/user/searchUser?page=${pageNu}&perPage=${pageSize}`;
      // due to auth0 limitation on free text search, check: https://auth0.com/docs/users/search/v3/query-syntax#wildcards
      if (qryText && qryText.length > 2) {
        url = `${url}&query=email:*${qryText}* OR name=*${qryText}*`;
      }
      return url;
    },
    GET_USER_DETAIL: (userId) => `${BASE_URL}um/api/v1/user/getUserDetailsById/${userId}`,
    CHANGE_USER_STATUS: (userId) => `${BASE_URL}um/api/v1/user/updateStatus/${userId}`,
    CREATE_USER: () => `${BASE_URL}um/api/v1/user/createUser`,
    UPDATE_USER: (userId) => `${BASE_URL}um/api/v1/user/updateUser/${userId}`,
    DELETE_USER: (userId) => `${BASE_URL}um/api/v1/user/deleteUser/${userId}`,
    GET_ROLE_LIST: () => `${BASE_URL}um/api/v1/role/getRoles`,
    CREATE_ROLE: () => `${BASE_URL}um/api/v1/role/createRole`,
    UPDATE_ROLE: (roleId) => `${BASE_URL}um/api/v1/role/updateRole/${roleId}`,
    DELETE_ROLE: (roleId) => `${BASE_URL}um/api/v1/role/delete/${roleId}`,
    GET_PERMISSIONS_LIST: () => `${BASE_URL}um/api/v1/permission/getPermissions`,
    CREATIVE_CATEGORIES: (query) => `${BASE_URL}mod/api/v1/moderation/category?${query}`,
    UPDATE_CREATIVE_CATEGORY: (marketId, categoryId) =>
      `${BASE_URL}mod/api/v1/moderation/market/${marketId}/category/${categoryId}`,
    UPDATE_CREATIVE_MOVEMENT: (creativeId) => `${BASE_URL}mod/api/v1/moderation/creative/${creativeId}/movement`,
    CREATIVE_ID_LOOKUP_API: (query) => `${BASE_URL}mod/api/v1/moderation/creative/externalId?${query}`,
    DSP_LOOKUP_API: (query) => `${BASE_URL}mod/api/v1/moderation/dsp?${query}`,
    MARKET_LOOKUP_API: (query) => `${BASE_URL}mod/api/v1/moderation/environment?${query}`,
    UPDATE_CREATIVE_MARKETS: () => `${BASE_URL}mod/api/v1/moderation/admin/creative/market`,
    FETCH_ADVERTISERS: (marketId, name) =>
      `${BASE_URL}mod/api/v1/moderation/advertiser?environment=${marketId}&name=${name}`,
    FETCH_AGENCY: (marketId, name) => `${BASE_URL}mod/api/v1/moderation/agency?environment=${marketId}&name=${name}`,
    UPDATE_AGENCY: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}/agency`,
    FETCH_SPECIALIST: (marketId, name) =>
      `${BASE_URL}mod/api/v1/moderation/specialist?environment=${marketId}&name=${name}`,
    UPDATE_SPECIALIST: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}/specialist`,
    DELETE_CREATIVE_COMMERCIAL: (commercialId) => `${BASE_URL}mod/api/v1/moderation/market/commercial/${commercialId}`,
    CREATE_CREATIVE_COMMERCIAL: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}/commercial`,
    UPDATE_CREATIVE_COMMERCIAL: (commercialId) => `${BASE_URL}mod/api/v1/moderation/market/commercial/${commercialId}`,
    FETCH_CREATIVE_FRAME_TAGS: (environment, query, marketId) => {
      if (marketId) {
        return `${BASE_URL}mod/api/v1/moderation/tag?environment=${environment}&query=${query}&marketId=${marketId}`;
      }

      return `${BASE_URL}mod/api/v1/moderation/tag?environment=${environment}&query=${query}`;
    },
    CREATE_CREATIVE_FRAME_TAG: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}/tag`,
    FETCH_ALL_CREATIVE_FRAME_TAGS: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}/tag`,
    DELETE_CREATIVE_FRAME_TAG: (marketTagId) => `${BASE_URL}mod/api/v1/moderation/market/tag/${marketTagId}`,
    UPDATE_CREATIVE_FRAME_TAG: (marketTagId) => `${BASE_URL}mod/api/v1/moderation/market/tag/${marketTagId}`,
    FETCH_CREATIVE_TAG_FRAME_DETAILS: (tagId) => `${BASE_URL}mod/api/v1/moderation/frame?tagId=${tagId}`,
    GET_CREATIVE_PRODUCT_FORMAT: (environment, query) =>
      `${BASE_URL}mod/api/v1/moderation/format?environment=${environment}&query=${query}`,
    ADD_CREATIVE_PRODUCT_FORMAT: (idMarket, idProductFormat) =>
      `${BASE_URL}mod/api/v1/moderation/market/${idMarket}/format/${idProductFormat}`,
    REMOVE_CREATIVE_PRODUCT_FORMAT: (idMarket, idProductFormat) =>
      `${BASE_URL}mod/api/v1/moderation/market/${idMarket}/format/${idProductFormat}`,
    DELETE_CREATIVE: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}`,
    RESTORE_CREATIVE: (marketId) => `${BASE_URL}mod/api/v1/moderation/market/${marketId}/restore`,
    FETCH_PRODUCT_FORMATS: () => `${BASE_URL}ag/api/sspui/v1/im/lookup/productFormat`,
    FETCH_CHANNELS: () => `${BASE_URL}ag/api/sspui/v1/im/lookup/channel`,
    FETCH_BUSINESS_AREAS: () => `${BASE_URL}ag/api/sspui/v1/im/lookup/businessArea`,
    FETCH_VISUAL_UNIT_CODES: () => `${BASE_URL}ag/api/v1/lookup/visualunitcodes`,
    FETCH_TAGS: () => `${BASE_URL}ag/api/sspui/v1/im/lookup/tag`,
    FETCH_NETWORKS: () => `${BASE_URL}ag/api/sspui/v1/im/lookup/network`,
    FETCH_ASSET_TYPES: () => `${BASE_URL}ag/api/sspui/v1/im/lookup/assetTypes`,
    FETCH_ASSET_TABLE: (query) => `${BASE_URL}ag/api/sspui/v1/im/filter/assets?${query}`,
    FETCH_ASSET_BY_ID: (id) => `${BASE_URL}ag/api/fs/v1/assets/${id}`,
    FETCH_CREATIVE_SETS_TABLE: (query) => `${BASE_URL}mod/api/v1/moderation/creative-sets?${query}`,
    FETCH_VISUAL_UNIT_GROUPS: (query) => `${BASE_URL}mod/api/v1/moderation/visual-units/groups?${query}`,
    CREATIVE_SET: (id) => `${BASE_URL}mod/api/v1/moderation/creative-sets/${id || ''}`,
    CREATE_DEAL: () => `${BASE_URL}ad/programmatic/v4/campaigns`,
    CREATE_LINE: (dealId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}/deals`,
    FETCH_DEAL_CONFIG: (marketId) => `${BASE_URL}ad/programmatic/v1/publisher/${marketId}/config`,
    FETCH_DEAL_MANAGEMENT_CONFIG: (marketId) => `${BASE_URL}ps/api/v1/publishers/${marketId}/deal-management`,
    FETCH_DEAL_PROCESS_STATUS: (dealId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}/status`,
    FETCH_DEAL: (dealId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}`,
    FETCH_LINE: (dealId, lineId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}/deals/${lineId}`,
    STOP_LINE: (dealId, lineId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}/deals/${lineId}/stop`,
    DELETE_LINE: (dealId, lineId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}/deals/${lineId}`,
    UPDATE_LINE: (dealId, lineId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}/deals/${lineId}`,
    EDIT_DEAL: (dealId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}`,
    PROGRAMMATIC_CAMPAIGNS_WITH_OOC_FRAMES: () => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/out-of-charge`,
    FETCH_ASSETS_SUMMARY: () => `${GATEWAY_BASE_URL}ad/programmatic/v4/assets/summary`,
    CHECK_AVAILABILITY: () => `${GATEWAY_BASE_URL}ad/programmatic/v4/assets/availability`,
    APPROVE_DEAL: (dealId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}/approve`,
    PROPOSE_DEAL: (dealId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}/send-for-approval`,
    REJECT_DEAL: (dealId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}/reject`,
    CANCEL_DEAL: (dealId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}/cancel`,
    GET_DEALS: (query) => `${BASE_URL}ad/programmatic/v4/campaigns?${query}`,
    CHECK_ALLOCATE: () => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/proposals`,
    FETCH_ALLOCATED_DEAL: (dealId) => `${GATEWAY_BASE_URL}ad/programmatic/v4/campaigns/${dealId}/proposal`,
    FETCH_NETWORK_GROUPS_TABLE: (query) => `${BASE_URL}ag/api/sspui/v1/im/filter/networkgroups?${query}`,
    FETCH_NETWORK_GROUPS: () => `${BASE_URL}ag/api/sspui/v1/im/lookup/networkGroup`,
    FETCH_NETWORKS_TABLE: (query) => `${BASE_URL}ag/api/sspui/v1/im/filter/networks?${query}`,
    FETCH_NETWORK_PRICE_DEFINITIONS_TABLE: (query) =>
      `${BASE_URL}ag/api/sspui/v1/im/filter/networkpricedefinitions?${query}`,
    FETCH_NETWORK_PRICE_DEFINITION: () => `${BASE_URL}ag/api/sspui/v1/im/lookup/networkPriceDefinition`,
    FETCH_COMMERCIAL_ENTITIES_TABLE: (query) => `${BASE_URL}ag/api/sspui/v1/im/filter/persons?${query}`,
    FETCH_PERSON_TYPES: () => `${BASE_URL}ag/api/sspui/v1/im/lookup/personTypes`,
    GET_PUBLISHER_CONFIGURATION: (externalPublisherId) =>
      `${BASE_URL}ps/api/v1/publishers/${externalPublisherId}/programmatic-platform`,
    GET_PUBLISHER_FEATURES: (externalPublisherId) =>
      `${BASE_URL}ps/api/v1/publishers/${externalPublisherId}/programmatic-platform-features`,
    GET_PUBLISHER_DIRECT_SALES_PRICING: (externalPublisherId) =>
      `${BASE_URL}ps/api/v1/publishers/${externalPublisherId}/dsm-pricing-service`,
    GET_PUBLISHER_DIRECT_SALES_CAMPAIGN_CONFIG: (externalPublisherId) =>
      `${BASE_URL}ps/api/v1/publishers/${externalPublisherId}/dsm-booking-service`,
    GET_PUBLISHER_VC_CONFIGURATION: (externalPublisherId) =>
      `${BASE_URL}ps/api/v1/publishers/${externalPublisherId}/viooh-central`,
    BULK_EDIT_CREATIVES_META: () => `${BASE_URL}mod/api/v1/moderation/market/batch/metadata`,
    BULK_EDIT_STATUS_CHANGE: () => `${BASE_URL}mod/api/v1/moderation/market/batch/status`,
    BULK_RESTORE_CREATIVES: () => `${BASE_URL}mod/api/v1/moderation/market/batch/restore`,
    BULK_EDIT_DELETE_SELECTED: () => `${BASE_URL}mod/api/v1/moderation/market/batch/delete`,
    FETCH_PRODUCT_CATEGORIES: (query) => `${BASE_URL}mod/api/v1/moderation/category?${query}`,
    FETCH_BRANDS: (query) => `${BASE_URL}mod/api/v1/moderation/brand?${query}`,
    SALES_PERSON_LOOKUP_API: (query) => `${BASE_URL}vcl/api/fs/v1/persons?${query}`,
    SALES_TEAM_LOOKUP_API: (query) => `${BASE_URL}vcl/api/fs/v1/salesTeams?${query}`,
    GET_AUTHENTICATION_TOKEN: (query) => `${BASE_URL}eaauth/api/v1/auth/token?${query}`,
    FETCH_PERMISSIONS: () => `https://keycloak.devel.viooh.net.cn/realms/dev-cn/protocol/openid-connect/token`,
    OPEN_STREET_MAP_OVERPASS: () => 'https://overpass-api.de/api/interpreter',
    FETCH_SECONDARY_AUDIENCE_AVERAGE_BY_SEGMENT_AND_HOUR: () =>
      `${BASE_URL}aud2/v1/carto3/secondary-audience-options/scores/frameAverageByHour`,
    FETCH_SECONDARY_AUDIENCE_OPTIONS: () => `${BASE_URL}aud2/v1/carto3/secondary-audience-options`,
    FETCH_AVERAGE_SEGMENT_SCORES_PER_FRAME: () =>
      `${BASE_URL}aud2/v1/carto3/secondary-audience-options/scores/hourAverageByFrame`,
    CHECK_DIRECT_SALES_AVAILABILITY: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/assets/${campaignId}/${dealLineId}/availability`,
    SEARCH_DIRECT_SALES_ASSETS: (marketId, campaignId, dealLineId, query) =>
      `${DSM_BASE_URL}api/v1/${marketId}/assets/${campaignId}/${dealLineId}/lookup?${query}`,
    DIRECT_SALES_CAMPAIGN: (marketId, campaignId) => `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}`,
    DIRECT_SALES_CAMPAIGN_ORIGINAL: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/definition/original`,
    CREATE_DIRECT_SALES_CAMPAIGN: (marketId) => `${DSM_BASE_URL}api/v1/${marketId}/booking`,
    CREATE_DIRECT_SALES_LINE: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/dealline`,
    APPLY_PRODUCT_TEMPLATE_TO_DEAL_LINE: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/dealline/${dealLineId}/apply-template`,
    CLEAR_PRODUCT_FROM_DEAL_LINE: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/dealline/${dealLineId}/clear-product`,
    FETCH_DIRECT_SALES_SOLUTION: (marketId, campaignId) => `${DSM_BASE_URL}api/v1/${marketId}/solution/${campaignId}`,
    FETCH_RESELLER_MEDIA_OWNERS: (reseller) => `${BASE_URL}ps/api/v1/publishers/${reseller}/common`,
    FETCH_RESELLER_MEDIA_OWNERS_CREATIVE_STATUS: (marketId) =>
      `${BASE_URL}mod/api/v1/moderation/market/${marketId}/reseller-media-owners`,
    FETCH_FINAL_ALLOCATION_REPORT: (campaignId, lineId, metricType) =>
      `${BASE_URL}ad/programmatic/v3/allocation-report/${campaignId}/deal/${lineId}/metric/${metricType}`,
    FETCH_PROPOSAL_ALLOCATION_REPORT: (proposalCampaignId, metricType) =>
      `${BASE_URL}ad/programmatic/v3/allocation-report/proposals/${proposalCampaignId}/metric/${metricType}`,
    FETCH_ALLOWED_STATE_TRANSITIONS_METADATA: (marketId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/dealLine/allowedTransitions`,
    FETCH_DIRECT_SALES_CAMPAIGN_STATE: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/state`,
    FETCH_DIRECT_SALES_DEAL_LINE_STATE: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/state/${dealLineId}`,
    UPDATE_DIRECT_SALES_DEAL_LINE_STATE: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/state/${dealLineId}`,
    UPDATE_DIRECT_SALES_CAMPAIGN_STATE: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/state`,
    DELETE_DIRECT_SALES_DEAL_LINE_STATE: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/state/${dealLineId}`,
    DELETE_DIRECT_SALES_CAMPAIGN_STATE: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/state`,
    FETCH_DIRECT_SALES_REFERENCE_DATA: () => `${BASE_URL}vcl/api/v1/assets/reference-data`,
    FETCH_LINE_IMPRESSION_METRICS: (query) =>
      `${BASE_URL}sps/api/summary-panel/v1/impressionMetrics/deal/date/${query}`,
    FETCH_CAMPAIGN_IMPRESSION_METRICS: (query) =>
      `${BASE_URL}sps/api/summary-panel/v1/impressionMetrics/campaign/date/${query}`,
    FETCH_DIRECT_SALES_NETWORKS_REFERENCE_DATA: () => `${BASE_URL}vcl/api/v1/assets/network-reference-data`,
    UPDATE_DIRECT_SALES_DEAL_LINE: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/dealline/${dealLineId}`,
    DUPLICATE_DIRECT_SALES_DEAL_LINE: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/dealline/${dealLineId}/duplicate`,
    DELETE_DIRECT_SALES_DEAL_LINE: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/dealline/${dealLineId}`,
    SPLIT_DIRECT_SALES_DEAL_LINE: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/dealline/${dealLineId}/split`,
    TERMINATE_DIRECT_SALES_DEAL_LINE: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/dealline/${dealLineId}/terminate`,
    UPDATE_TRANSIENT_DEAL_STATE: (marketId, campaignId) => `${DSM_BASE_URL}api/v1/${marketId}/transient/${campaignId}`,
    TERMINATE_DIRECT_SALES_CAMPAIGN_SESSION: (externalPublisherId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${externalPublisherId}/booking/${campaignId}/unlock`,
    EXTEND_DIRECT_SALES_CAMPAIGN_SESSION_LOCK: (externalPublisherId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${externalPublisherId}/booking/${campaignId}/extend-lock`,
    FETCH_DIRECT_SALES_ALLOCATION_REPORT: (publisherId, campaignId, dealLineId, metricType) =>
      `${DSM_BASE_URL}api/v1/${publisherId}/allocation-report/campaign/${campaignId}/deal-line/${dealLineId}/metric/${metricType}`,
    FETCH_DIRECT_SALES_FILTERED_CAMPAIGNS_TABLE: (externalPublisherId, query) =>
      `${DSM_BASE_URL}api/v1/${externalPublisherId}/filter/bookings/full?${query}`,
    FETCH_DIRECT_SALES_SOLUTION_SUMMARY: (publisherId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${publisherId}/solution/${campaignId}/summary`,
    UPDATE_DIRECT_SALES_TRANSIENT_DEAL_LINE_STATE: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/targetStates`,
    CREATE_DIRECT_SALES_PRODUCT_TEMPLATE: (marketId) => `${DSM_BASE_URL}api/v1/${marketId}/template`,
    TOGGLE_DIRECT_SALES_PRODUCT_STATUS: (marketId, productId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/template/${productId}/status`,
    FETCH_DIRECT_SALES_PRODUCT_FOLDER: (marketId) => `${DSM_BASE_URL}api/v1/${marketId}/template/folders`,
    FETCH_DIRECT_SALES_PRODUCT: (marketId, productId) => `${DSM_BASE_URL}api/v1/${marketId}/template/${productId}`,
    FETCH_DIRECT_SALES_ALL_PRODUCT_LIST: (marketId) => `${DSM_BASE_URL}api/v1/${marketId}/template`,
    FETCH_DIRECT_SALES_FILTERED_PRODUCT_LIST: (marketId, query) => `${DSM_BASE_URL}api/v1/${marketId}/template${query}`,
    UPDATE_DIRECT_SALES_GRID: (marketId, campaignId) => `${DSM_BASE_URL}api/v1/${marketId}/grid/${campaignId}`,
    CAMPAIGN_REPORTING_TOKEN: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/reporting/token/${campaignId}`,
    FETCH_CAMPAIGN_PLAN: (token) => `${DSM_BASE_URL}api/v1/token/${token}/campaign-plan`,
    FETCH_PUBLIC_ALLOCATION_REPORT: (token, dealLine, metric) =>
      `${DSM_BASE_URL}api/v1/token/${token}/allocation-report/deal-line/${dealLine}/metric/${metric}`,
    ENABLE_DIRECT_SALES_SHARED_CAMPAIGN: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/share`,
    DISABLE_DIRECT_SALES_SHARED_CAMPAIGN: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/share`,
    FETCH_CAMPAIGN_IS_SHARABLE: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/is-sharable`,
    FETCH_RESHUFFLE_CANDIDATES: (marketId, campaignId, targetDealLineId, size = 10) =>
      `${DSM_BASE_URL}api/v1/${marketId}/reshuffle/booking/${campaignId}/dealline/${targetDealLineId}/candidates?size=${size}`,
    CREATE_RESHUFFLE_SIMULATION: (marketId, campaignId, targetDealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/reshuffle/booking/${campaignId}/dealline/${targetDealLineId}/simulate`,
    FETCH_RESHUFFLE_SIMULATION_STATUS: (marketId, reshuffleId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/reshuffle/${reshuffleId}/status`,
    FETCH_RESHUFFLE_SIMULATION_RESULT: (marketId, reshuffleId, size) =>
      `${DSM_BASE_URL}api/v1/${marketId}/reshuffle/${reshuffleId}/results?size=${size}`,
    DECLINE_RESHUFFLE_SIMULATION: (marketId, reshuffleId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/reshuffle/${reshuffleId}/decline`,
    ACCEPT_RESHUFFLE_SIMULATION: (marketId, reshuffleId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/reshuffle/${reshuffleId}/accept`,
    FETCH_DIRECT_SALES_CAMPAIGN_FRAME_LIST_REPORT: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/frame-list-report/${campaignId}`,
    FETCH_DIRECT_SALES_CAMPAIGN_LINES_INFO: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/lite`,
    FETCH_DIRECT_SALES_TAXONOMY_REFERENCE_DATA: (marketId) =>
      `${DSM_BASE_URL}v1/audiences/secondary/${marketId}/taxonomy`,
    FETCH_HOUR_AVERAGE_BY_FRAME: (marketId) =>
      `${BASE_URL}aud2/v1/audiences/secondary/${marketId}/scores/hourAverageByFrame`,
    FETCH_CAMPAIGN_POLYGONS: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/meta-type/polygon/list`,
    FETCH_LINE_POLYGONS: (marketId, campaignId, lineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/deal-line/${lineId}/meta-type/polygon`,
    CREATE_LINE_POLYGON: (marketId, campaignId, lineId, polygonId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/deal-line/${lineId}/meta-type/polygon/${polygonId}`,
    DELETE_LINE_POLYGON: (marketId, campaignId, lineId, polygonId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/deal-line/${lineId}/meta-type/polygon/${polygonId}`,
    FETCH_DIRECT_SALES_AVAILABILITY_REPORT: (marketId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/availability/report/progressive`,
    DIRECT_SALES_POI_DATA: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/booking/${campaignId}/dealline/${dealLineId}/pois`,
    FETCH_PENDING_CREATIVE_COUNT: (publisherId) =>
      `${BASE_URL}mod/api/v1/moderation/reporting/creative/pending-count?publisher=${publisherId}`,
    FETCH_EMAIL_NOTIFICATION_CONFIG: (publisher) => `${BASE_URL}mod/api/v1/moderation/email-notification/${publisher}`,
    ENABLE_EMAIL_NOTIFICATION: () => `${BASE_URL}mod/api/v1/moderation/email-notification/enable`,
    DISABLE_EMAIL_NOTIFICATION: (publisher) =>
      `${BASE_URL}mod/api/v1/moderation/email-notification/disable/${publisher}`,
    DOWNLOAD_DIRECT_SALES_AVAILABILITY_REPORT: (marketId) => `${DSM_BASE_URL}api/v1/${marketId}/availability/download`,
    FETCH_ADVANCED_DIRECT_SALES_AVAILABILITY_REPORT_EXPORT_ID: (marketId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/availability/advance/download`,
    FETCH_ADVANCED_DIRECT_SALES_AVAILABILITY: (marketId, exportId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/availability/advance/download/${exportId}/status`,
    DOWNLOAD_ALLOCATION_SUMMARY: (marketId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/allocation-summary/${campaignId}/download`,
    FETCH_BOOKED_CAMPAIGNS: (marketId) => `${DSM_BASE_URL}api/v1/${marketId}/assets/occupancy`,
    DIRECT_SALES_NETWORK_AVAILABILITY: (marketId, campaignId, dealLineId) =>
      `${DSM_BASE_URL}api/v1/${marketId}/assets/${campaignId}/${dealLineId}/availability/networks`,
    DIRECT_SALES_CAMPAIGNS_WITH_OOC_FRAMES: (marketId) => `${DSM_BASE_URL}api/v1/${marketId}/frame-status/ooc`,
    SAVE_CAMPAIGN_PLAN_CONFIG: (publisherId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${publisherId}/booking/${campaignId}/meta-type/campaign_plan_config/`,
    FETCH_CAMPAIGN_PLAN_CONFIG: (publisherId, campaignId) =>
      `${DSM_BASE_URL}api/v1/${publisherId}/booking/${campaignId}/meta-type/campaign_plan_config/`,
    GET_EXPORTER_JOB_HISTORY: () => `${BASE_URL}vsa/api/screens/v3/vtm/exporter/jobs`,
    CREATE_EXPORTER_JOB: () => `${BASE_URL}vsa/api/screens/v3/vtm/exporter/job`,
    GET_EXPORTER_JOB_STATUS: (jobId) => `${BASE_URL}vsa/api/screens/v3/vtm/exporter/jobs/${jobId}/status`,
    GET_EXPORTER_JOB_DOWNLOAD_URL: (jobId) => `${BASE_URL}vsa/api/screens/v3/vtm/exporter/jobs/${jobId}/download`,
  }),
  HTTP_METHODS: {
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
  },
  features: () => {
    return {
      DEAL_LEVEL_CPM: true,
      OVERRIDE_DEAL_ID: false,
    };
  },
};
